export default __webpack_public_path__ + "static/media/p33.05e51bfd.jpg";